import { useRef, useState, useCallback } from 'react';

// Evita ejecuciones concurrentes de una acción async (ej: doble click en "Guardar").
// Devuelve [ejecutando, guard(fn)] — guard ignora llamadas mientras fn ya está en curso.
//
// Uso:
//   const [guardando, guard] = useAsyncGuard();
//   <button disabled={guardando} onClick={() => guard(saveTarea)}>Guardar</button>
export function useAsyncGuard() {
  const enCursoRef = useRef(false);
  const [ejecutando, setEjecutando] = useState(false);

  const guard = useCallback(async (fn) => {
    if (enCursoRef.current) return;
    enCursoRef.current = true;
    setEjecutando(true);
    try {
      await fn();
    } finally {
      enCursoRef.current = false;
      setEjecutando(false);
    }
  }, []);

  return [ejecutando, guard];
}
